import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import Auth from "../pages/auth";
import ContactInfo from "../pages/contactInfo";
import Dashboard from "../pages/dashboard";
import Delegation from "../pages/delegation";
import ForgotPassword from "../pages/forgotPassword";
import IndividualDelegation from "../pages/individualDelegation";
import UserDetails from "../pages/userDetails";
import { getDataFromLocalStorage } from "../utils";
// import { getDataFromLocalStorage } from "../utils";

const AppRoutes = () => {
  const [appLoader, setappLoader] = useState(false);
  const [user, setUser] = useState(false);
  const [userStateFetched, setuserStateFetched] = useState(false);

  useEffect(() => {
    let user = getDataFromLocalStorage("userData");
    if (user) {
      user = JSON.parse(user);
      setUser(user);
    }
    setuserStateFetched(true);
  }, []);

  return (
    // dataFetched ?
    <Router>
      <AppContext.Provider
        value={{
          appLoadingStates: {
            appLoader,
            setappLoader,
            user,
            setUser,
            userStateFetched,
          },
        }}
      >
        <Routes>
          <Route path="/" element={<Auth />} exact />
          <Route path="/dashboard/:id" element={<Dashboard />} exact />
          <Route path="/contact-info" element={<ContactInfo />} exact />
          <Route path="/forgot-password" element={<ForgotPassword />} exact />
          <Route
            path="/dashboard/individual_delegation/:id"
            element={<IndividualDelegation />}
            exact
          />
          <Route
            path="/dashboard/delegation/:id"
            element={<Delegation />}
            exact
          />

          <Route path="/dashboard/user/:id" element={<UserDetails />} />
        </Routes>
      </AppContext.Provider>
    </Router>
  );
};

export default AppRoutes;
